import { createProfessionalExporter } from '../../utils/professionalExport';

const headers = [
  'Equipment Name',
  'Company Name',
  'Category',
  'Location',
  'Quantity',
  'Status',
  'Remarks',
];

function formatStatus(status) {
  if (status === 'in-use') return 'In Use';
  return status ? status.charAt(0).toUpperCase() + status.slice(1) : '—';
}

const exporter = createProfessionalExporter({
  title: 'Equipment List',
  headers,
  slug: 'equipments',
  getRows: (list) => list.map((e) => [
    e.name || '—',
    e.companyName || '—',
    e.category || '—',
    e.location || '—',
    e.quantity != null ? e.quantity : 1,
    formatStatus(e.status),
    e.remarks || '—',
  ]),
  getSummary: (list) => [
    `Total equipment: ${list.length}`,
    `Available: ${list.filter((e) => e.status === 'available').length}`,
    `Maintenance: ${list.filter((e) => e.status === 'maintenance').length}`,
  ],
});

export const printEquipmentList = (data) => exporter.print(data);
export const exportEquipmentCsv = (data) => exporter.csv(data);
export const exportEquipmentExcel = (data) => exporter.excel(data);
export const exportEquipmentPdf = (data) => exporter.pdf(data);
export const exportEquipments = (data) => exporter.export(data);
